




















































































































































import {
  Vue,
  Component,
  Prop,
  Watch,
} from "@/shared/vuepack";
import {
  CommunicationKitType,
  EmployerEditSuppressionType,
} from "@/shared/types";
import Input from "@/shared/components/ui/Input.vue";
import Select from "@/shared/components/ui/Select.vue";
import moment from "moment";
import { Validator } from "vee-validate";
import { BankCustodian } from "@/admin/types";
import { useNotifierStore } from "@/shared/store/notifier";
import { usePartnerSettingStore } from "@/shared/store/partnerSetting";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";

@Component({
  components: {
    Select,
    Input
  }
})
export default class PartnerSettings extends Vue {

  partnerSettingStore = usePartnerSettingStore();
  notifierStore = useNotifierStore();
  featureFlagStore = useFeatureFlagStore();

  @Prop() custodian: BankCustodian;

  @Prop() partnerId: string;

  get partnerIdAsNumber (): number {
    return parseInt(this.partnerId);
  }

  $validator: Validator;
  CommunicationKitType = CommunicationKitType;
  EmployerEditSuppressionType = EmployerEditSuppressionType;
  canErUpdateCensus = true;
  canViewErSsn = false;
  isSubmitting = false;
  isLoaded = false;
  submitDisabled = false;
  usesCustomClaims = false;
  enableClaimsOptIn = false;
  usersAreAutomaticallyRedirectedToWex = false;
  disableTalon = null;
  employerId = 0;
  employeeLogoutRedirectUrl = null;
  communicationKitType = CommunicationKitType.None;
  employerEditSuppressionType = EmployerEditSuppressionType.None;
  waiverType = 0;
  emailFromAddress = "";
  emailFromName = "";
  showEmployerSignupQuestion = false;
  consumerLiveChatEnabled = false;
  isEnrollmentDisabled = false;
  dateStopEmployeeContribution = null;
  dateStopEmployeeContributionLoadedValue = null;
  dateTomorrow = moment().add(1, "d").format("MM/DD/YYYY");
  disableInvestmentActivity = false;

  communicationKitTypeSelectOptions = [
    { value: CommunicationKitType.None, text: "None" },
    { value: CommunicationKitType.BendBranded, text: "Bend Branded" }
  ];

  employerEditSuppressionOptions = [
    { value: EmployerEditSuppressionType.None, text: "None" },
    { value: EmployerEditSuppressionType.HsaBankImportedProperties, text: "HSA Bank Imported Fields" }
  ];

  mounted () {
    this.partnerSettingStore.loadPartnerSettings(this.partnerIdAsNumber);
  }

  get showCheckBoxToRedirectUsersToWex () {
    return this.custodian === BankCustodian.HsaBank;
  }

  @Watch("usersAreAutomaticallyRedirectedToWex")
  onUsersAreAutomaticallyRedirectedToWexChange () {
    if (this.usersAreAutomaticallyRedirectedToWex) {
      this.disableTalon = true;
    }
  }

  talonPopupOpen = false;

  prevTalon = null;

  @Watch("disableTalon")
  onDisableTalonChange () {
    if (this.prevTalon !== null) {
      this.talonPopupOpen = true;
    }
    this.prevTalon = this.disableTalon;
  }

  get talonPopupText () {
    return this.disableTalon ?
        "If you save this, Talon will receive mass-update to terminate users."
        : "If you save this, Talon will receive mass-update to add users.";
  }

  onCloseTalonPopup () {
    this.talonPopupOpen = false;
  }

  get dateStopEmployeeContributionInputValidation () {
    const dateLoaded = moment(this.dateStopEmployeeContributionLoadedValue).format("MM/DD/YYYY");
    const dateInput = moment(this.dateStopEmployeeContribution).format("MM/DD/YYYY");

    if (dateLoaded === dateInput) {
      return "";
    }

    return `validateDateIsAfter:${this.dateTomorrow}`;
  }

  @Watch("partnerSettingStore.settings", { deep: true })
  onSettingsChange () {
    this.isLoaded = true;
    this.submitDisabled = false;
    this.canErUpdateCensus = this.partnerSettingStore.settings.canEmployerUpdateCensus;
    this.canViewErSsn = this.partnerSettingStore.settings.canViewEmployerSsns;
    this.usersAreAutomaticallyRedirectedToWex = this.partnerSettingStore.settings.usersAreAutomaticallyRedirectedToWex;
    this.usesCustomClaims = this.partnerSettingStore.settings.partnerUsesCustomClaims;
    this.employeeLogoutRedirectUrl = this.partnerSettingStore.settings.employeeLogoutRedirectUrl;
    this.communicationKitType = this.partnerSettingStore.settings.communicationKitType;
    this.employerEditSuppressionType = this.partnerSettingStore.settings.employerEditSuppressionType;
    this.emailFromName = this.partnerSettingStore.settings.advisorEmailName;
    this.emailFromAddress = this.partnerSettingStore.settings.advisorEmailFrom;
    this.enableClaimsOptIn = this.partnerSettingStore.settings.claimsOptIn;
    this.disableTalon = this.partnerSettingStore.settings.disableTalon;
    this.showEmployerSignupQuestion = this.partnerSettingStore.settings.showEmployerSignupQuestion;
    this.consumerLiveChatEnabled = this.partnerSettingStore.settings.consumerLiveChatEnabled;
    this.isEnrollmentDisabled = this.partnerSettingStore.settings.isEnrollmentDisabled;
    this.dateStopEmployeeContribution = this.partnerSettingStore.settings.dateStopEmployeeContribution;
    this.dateStopEmployeeContributionLoadedValue = this.partnerSettingStore.settings.dateStopEmployeeContribution;
    this.disableInvestmentActivity = this.partnerSettingStore.settings.disableInvestmentActivity;
  }

  submit () {
    if (this.submitDisabled) return;

    this.$validator.validate().then(x => {
      if (x) {
        this.continueSubmission();
      } else {
        this.submitDisabled = false;
      }
    });
  }

  continueSubmission () {
    this.submitDisabled = true;
    return this.partnerSettingStore.beginSetPartnerSettings({
          partnerId: this.partnerIdAsNumber,
          canEmployerUpdateCensus: this.canErUpdateCensus,
          canViewEmployerSsns: this.canViewErSsn,
          usersAreAutomaticallyRedirectedToWex: this.usersAreAutomaticallyRedirectedToWex,
          partnerUsesCustomClaims: this.usesCustomClaims,
          employeeLogoutRedirectUrl: this.employeeLogoutRedirectUrl,
          communicationKitType: this.communicationKitType,
          employerEditSuppressionType: this.employerEditSuppressionType,
          advisorEmailFrom: this.emailFromAddress,
          advisorEmailName: this.emailFromName,
          claimsOptIn: this.enableClaimsOptIn,
          disableTalon: this.disableTalon,
          showEmployerSignupQuestion: this.showEmployerSignupQuestion,
          consumerLiveChatEnabled: this.consumerLiveChatEnabled,
          isEnrollmentDisabled: this.isEnrollmentDisabled,
          dateStopEmployeeContribution: this.dateStopEmployeeContribution ?
              moment(this.dateStopEmployeeContribution).format("MM/DD/YYYY") : null,
          disableInvestmentActivity: this.disableInvestmentActivity
        })
        .then(() => {
          this.$nextTick(() => this.notifierStore.setSuccess("Partner settings saved"));
        })
        .finally(() => {
          this.submitDisabled = false;
        });
  }
}
